/* mootlu-consent.js — simple cookie notice banner (vanilla, no React). */
(function () {
  'use strict';

  var STORAGE_KEY = 'mootlu_cookie_notice';
  var banner = null;
  var acceptBtn = null;
  var version = '1';

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ version: version, ts: Date.now() })
      );
    } catch (e) { /* private browsing */ }
  }

  function isDismissed() {
    var stored = readStored();
    return !!(stored && String(stored.version) === String(version));
  }

  function setBodyVisible(visible) {
    document.body.classList.toggle('mootlu-cookie-visible', visible);
  }

  function showBanner() {
    if (!banner) return;
    banner.removeAttribute('hidden');
    banner.classList.add('is-visible');
    setBodyVisible(true);
  }

  function hideBanner(persist) {
    if (!banner) return;
    if (persist) writeStored();
    banner.setAttribute('hidden', '');
    banner.classList.remove('is-visible');
    setBodyVisible(false);
  }

  function dismiss() {
    hideBanner(true);
  }

  function open() {
    showBanner();
  }

  function init() {
    banner = document.getElementById('mootlu-cookie-banner');
    if (!banner) return;

    version = banner.getAttribute('data-consent-version') || '1';
    acceptBtn = banner.querySelector('[data-cookie-accept]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', dismiss);
    }

    if (!isDismissed()) {
      showBanner();
    }
  }

  window.MootluConsent = {
    open: open,
    dismiss: dismiss,
    isDismissed: isDismissed,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
